import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import nl from 'dayjs/locale/nl'
import fr from 'dayjs/locale/fr'
import de from 'dayjs/locale/de-at' // CCC German is Austrian locale
import es from 'dayjs/locale/es'
import en from 'dayjs/locale/en-gb'
import { LoadingIndicator } from '@dhl/components'
import { useReturnPortal } from '~/hooks'
import { ReturnFormContainer } from '~/components'
import { BasePage } from '~/pages'
import { languageForBusinessUnit } from '~/i18n'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translationsMap: Record<string, any> = { nl, fr, en, es, de }

export const ReturnStartPage = () => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const { returnPortal, isLoading } = useReturnPortal()
  const languages = returnPortal ? languageForBusinessUnit(returnPortal.businessUnitCode) : []

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={translationsMap[language] || nl}>
      <BasePage isLoading={false} languages={languages}>
        {!returnPortal && !isLoading && (
          <Grid container justifyContent="center" alignItems="center" size={12}>
            <Grid>
              <Typography align="center">{t('noPortalFound')}</Typography>
            </Grid>
          </Grid>
        )}
        {isLoading && <LoadingIndicator />}
        {returnPortal && <ReturnFormContainer returnPortal={returnPortal} />}
      </BasePage>
    </LocalizationProvider>
  )
}
